// @flow
import { connect } from 'react-redux';

import TestAbSwitch from '.';
import { isSpecificTestAbOption } from '../../selectors';

type OwnProps = {
  id: string,
  option: string,
};

type MapStateToProps = {
  isTestAbOption: boolean,
};

export function mapStateToProps(state: Object, { id, option }: OwnProps): MapStateToProps {
  return {
    isTestAbOption: isSpecificTestAbOption(state, id, option),
  };
}

const TestAbSwitchContainer = connect(mapStateToProps)(TestAbSwitch);

TestAbSwitchContainer.displayName = 'TestAbSwitchContainer';

export default TestAbSwitchContainer;



// WEBPACK FOOTER //
// ./app/TestAb/components/TestAbSwitch/container.js